var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
/**
 * @module user
 * @description 用户相关模块
 * @author Yawei Wang
 * @date 2019-06-03 11:05:51
 */


import { ajax, utils } from '../index';
import axios from 'axios';
import * as cookie from '../cookie';
/**
 * 验证集成登录
 * @function
 * @param {Function} success
 * @param {Function} fail
 * @param {String} flag 接口标识
 */

export var ssoLogin = function ssoLogin(cb, isCompany, flag) {
  var url = utils.getSitePreUrl('passport') + "/sso/login";
  axios.defaults.withCredentials = true;
  axios.get(url, {
    headers: {
      crossDomain: true
    }
  }).then(function (respon) {
    var data = respon.data;

    if (data.error_code === 0) {
      var url_1 = isCompany ? '/api/v2/user/signin/sso' : (flag || '') + '/api/user/signin/sso';
      ajax.postJson(url_1, {
        ticket: data.ticket
      }).then(function (resp) {
        if (resp.error_code === 0 && cb) {
          cb(resp);
        }
      });
    }
  });
};
/**
 * 退出登录
 * @function
 * @param {Function} cb 成功回调函数
 */

export var ssoLoginOut = function ssoLoginOut(cb) {
  if (cb === void 0) {
    cb = function cb() {};
  }

  ajax.postJson('/api/sso/signout').then(function (res) {
    if (res.error_code === 0) {
      cookie.remove('session_ent');
      cb();
    }
  });
};
/**
 * 获取用户信息
 * @function
 * @param {Function} cb 回调函数
 * @param {Function} isCompany 是否企业
 * @param {String} flag 接口标识
 */

export var profileFn = function profileFn(cb, isCompany, flag) {
  var ticket = utils.getQueryString('ticket');
  var loc = window.location;

  if (loc.hostname !== 'localhost' && ticket) {
    var url = isCompany ? '/api/v2/user/signin/sso' : (flag || '') + '/api/user/signin/sso';
    ajax.postJson(url, {
      ticket: ticket
    }).then(function (resp) {
      if (resp.error_code === 0 && cb) {
        cb(resp);
      }
    });
  } else {
    var url = isCompany ? '/api/user/profile' : (flag || '') + '/api/user';
    ajax.getJson(url).then(function (res) {
      if (res.error_code === 0) {
        cb(res);
      } else if (loc.hostname !== 'localhost') {
        ssoLogin(cb, isCompany, flag);
      }
    });
  }
};
/**
 * @function
 * @param {Boolean} isCompany 是否企业
 * @param {String} flag 接口标识
 */

export var AsyncProfileFn = function AsyncProfileFn(isCompany, flag) {
  return __awaiter(void 0, void 0, void 0, function () {
    var ticket, loc, url, res, url, res, url_2, respon, data, url_3, resp;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          ticket = utils.getQueryString('ticket');
          loc = window.location;
          if (!(loc.hostname !== 'localhost' && ticket)) return [3
          /*break*/
          , 2];
          url = isCompany ? '/api/v2/user/signin/sso' : (flag || '') + '/api/user/signin/sso';
          return [4
          /*yield*/
          , ajax.postJson(url, {
            ticket: ticket
          })];

        case 1:
          res = _a.sent();
          return [2
          /*return*/
          , res];

        case 2:
          url = isCompany ? '/api/user/profile' : (flag || '') + '/api/user';
          return [4
          /*yield*/
          , ajax.getJson(url)];

        case 3:
          res = _a.sent();
          if (!(res.error_code !== 0 && loc.hostname !== 'localhost')) return [3
          /*break*/
          , 7];
          url_2 = utils.getSitePreUrl('passport') + "/sso/login";
          axios.defaults.withCredentials = true;
          return [4
          /*yield*/
          , axios.get(url_2, {
            headers: {
              crossDomain: true
            }
          })];

        case 4:
          respon = _a.sent();
          data = respon.data;
          if (!(data.error_code === 0)) return [3
          /*break*/
          , 6];
          url_3 = isCompany ? '/api/v2/user/signin/sso' : (flag || '') + '/api/user/signin/sso';
          return [4
          /*yield*/
          , ajax.postJson(url_3, {
            ticket: data.ticket
          })];

        case 5:
          resp = _a.sent();
          return [2
          /*return*/
          , resp];

        case 6:
          return [2
          /*return*/
          , data];

        case 7:
          return [2
          /*return*/
          , res];
      }
    });
  });
};
/**
 * 执行sso操作
 * @function
 * @param {Function} cb 回调操作
 */

export var AsyncSso = function AsyncSso(cb) {
  return __awaiter(void 0, void 0, void 0, function () {
    var url, respon, data;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          url = utils.getSitePreUrl('passport') + "/sso/login";
          axios.defaults.withCredentials = true;
          return [4
          /*yield*/
          , axios.get(url, {
            headers: {
              crossDomain: true
            }
          })];

        case 1:
          respon = _a.sent();
          data = respon.data;

          if (data.error_code === 0 && cb) {
            cb();
          }

          return [2
          /*return*/
          ];
      }
    });
  });
};
/**
 * 跳转登录
 * @function
 * @param {String} [key='signin'] passport login path
 * @param {String} [path] return_url
 */

export var goLogin = function goLogin(key, path) {
  if (key === void 0) {
    key = 'signin';
  }

  var loc = window.location;

  if (loc.hostname === 'localhost' || loc.hostname.indexOf('191.168') >= 0) {
    window.location.href = '/login?redirect=' + loc.pathname;
  } else {
    var url = utils.getSitePreUrl('passport') + "/" + key;

    if (!path) {
      var search = loc.search.substr(1);
      var arr = []; // 处理多次拼接ticket的情况

      if (search) {
        arr = search.split('&').filter(function (cur) {
          return cur.indexOf('ticket=') < 0 && cur.indexOf('next=') < 0 && cur.indexOf('islogin=') < 0;
        });
      }

      var url_4 = loc.origin;

      if (arr && arr.length) {
        url_4 += "?" + arr.join('&');
      }

      path = encodeURIComponent(url_4);
    } else {
      path = encodeURIComponent(path);
    }

    window.location.href = url + "?return_url=" + path;
  }
};
/**
 * 获取登录地址
 * @function
 * @param {String} key
 * @param {String} path 回调url
 */

export var getLoginUrl = function getLoginUrl(key, path) {
  if (key === void 0) {
    key = 'signin';
  }

  var loc = window.location;

  if (loc.hostname === 'localhost' || loc.hostname.indexOf('191.168') >= 0) {
    return '/login?redirect=' + loc.pathname;
  } else {
    var url = utils.getSitePreUrl('passport') + "/" + key;

    if (!path) {
      path = encodeURIComponent(loc.href);
    } else {
      path = encodeURIComponent(path);
    }

    return url + "?return_url=" + path;
  }
};